import $ from 'jquery';
import {
  ADD_NEW_AD_RULE,
  IMPORT_SETTINGS,
  RESET_DATA,
  REMOVE_AD_RULE,
  START_TEST,
  UPDATE_AD_BREAK,
  UPDATE_AD_RULE,
  UPDATE_AD_RULES,
  UPDATE_LOGS,
  SET_SSAR,
  REGISTER_PLUGIN,
  postConfigurationSuccess,
  postConfigurationFailure,
  fetchConfigurationSuccess,
  postConfigurationRequest,
} from '../actions';
import {
  checkUniqueError,
  getCurrentDate,
  getVastParserLog,
  inputsValidator,
  setLocalStorage,
  startPlayer,
  stopPlayer,
  updateSize,
  removeLocalStorage,
  createExportConfigurationObject,
  importSettings,
} from '../helpers/tools';
import { configServerProdUrl, initStateObj, isMobile, sections } from '../constants/Constants';

/**
 * Logger middleware, to display in console next state of app
 * @param {object} store state of app
 * @param {function} next dispatch function
 * @param {object} action redux action object
 */
const logger = store => next => action => {
  // eslint-disable-next-line no-console
  console.log('dispatching', action);
  let result = next(action);
  // eslint-disable-next-line no-console
  console.log('next state', store.getState());
  return result;
};

/**
 * showcaseMiddleware middleware, connect wiht controller, register plugin, retrive and parse logs
 * @param {object} store state of app
 * @param {function} next dispatch function
 * @param {object} action redux action object
 */
const showcaseMiddleware = store => next => action => {
  const state = store.getState();

  switch (action.type) {
    case ADD_NEW_AD_RULE:
      action = addNewAdruleAction(action, state);
      break;

    case IMPORT_SETTINGS:
      action = validateImportSettings(action);
      break;

    case REGISTER_PLUGIN:
      registerPlugin(state, null, null, null);
      break;

    case REMOVE_AD_RULE:
      action = removeAdRuleAction(action, state);
      break;

    case RESET_DATA:
      handleResetData(state, action);
      break;

    case SET_SSAR:
      handleSetSsar(state, action);
      break;

    case START_TEST:
      handleStartTest(state);
      break;

    case UPDATE_AD_BREAK:
      action = updateAdBreakAction(action, state);
      break;

    case UPDATE_AD_RULE:
      action = updateAdRuleAction(action, state);
      break;

    case UPDATE_LOGS:
      action = updateLogAction(action, state);
      break;

    default:
      break;
  }

  next(action);
};

function handleResetData(state, action) {
  const tabsMap = [
    { dataName: 'vastSource' },
    {
      subTabs: [
        { dataName: 'adData' },
        { dataName: 'adRules' },
        { dataName: 'configuration' },
        { dataName: 'other' },
      ],
    },
  ];

  //To close all the pop ups
  $(document).trigger(isMobile ? 'touchend' : 'mousedown');

  const section = tabsMap[state.activeSection];
  const dataName = section.subTabs ? section.subTabs[state.subTab].dataName : section.dataName;

  // Clear ad break rows
  if (state.adRules.data) {
    for (const [index] of state.adRules.data.entries()) {
      removeLocalStorage('AdBreakRow' + index);
    }
  }

  action.data = { [dataName]: initStateObj[dataName] };

  // Handle special cases
  handleResetDataSpecialCases(state, action, dataName);

  setLocalStorage(dataName, '');
  $('.validationError').hide();
}

function handleResetDataSpecialCases(state, action, dataName) {
  if (dataName === 'vastSource') {
    removeLocalStorage('vastSample');
  }
  // SSAR is in adRules tab but in configuration part of state, so it has to be setup separately
  if (dataName === 'adRules') {
    state.configuration.publisher.enableSSAR = false;
    setLocalStorage('configuration', JSON.stringify(state.configuration));
  } else if (dataName === 'configuration') {
    action.data[dataName].publisher.enableSSAR = state.configuration.publisher.enableSSAR;
  }
  // banner settings is in placement tab, while in cofig in other section, so it has to be setup separately
  if (dataName === 'adData') {
    Object.assign(state.configuration.banner, {
      sas_format_banners: '',
      sas_target_banners: '',
    });
    setLocalStorage('configuration', JSON.stringify(state.configuration));
  }
}

function handleSetSsar(state, action) {
  const configuration = { ...state.configuration };
  configuration.publisher.enableSSAR = action.active;
  setLocalStorage('configuration', JSON.stringify(configuration));
}

function handleStartTest(state) {
  if (state.activeSection === sections.VAST_INSPECTOR) {
    inspectVast(state);
  } else if (state.activeSection === sections.PLUGIN_SETTINGS) {
    updatePluginWithData(state);
  }
}

export const postConfiguration = () => {
  return async (dispatch, getState) => {
    try {
      dispatch(postConfigurationRequest());
      const configurationObject = createExportConfigurationObject(getState());

      const res = await fetch(configServerProdUrl, {
        method: 'POST',
        body: JSON.stringify(configurationObject),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const json = await res.json();

      dispatch(postConfigurationSuccess(`${globalThis.location.origin}?psettings=${json.id}`));
    } catch (e) {
      dispatch(postConfigurationFailure('Share option is not available now'));
    }
  };
};

export const fetchConfiguration = id => {
  return async dispatch => {
    try {
      const res = await fetch(`${configServerProdUrl}/${id}`);

      const json = await res.json();
      const config = importSettings(JSON.stringify(json.showcaseConfig));

      dispatch(fetchConfigurationSuccess(config));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };
};

/**
 * Helper function to add a new ad rule and set the new cookie value
 * @param {object} action redux Action object
 * @param {object} state The current state of app
 */
const addNewAdruleAction = (action, state) => {
  let adRules = JSON.parse(JSON.stringify(state.adRules));

  adRules.data.push({
    data: {},
  });

  setTimeout(updateSize, 0);

  return {
    type: UPDATE_AD_RULES,
    adRules: adRules,
  };
};

/**
 * Helper function to pause content player and call register method
 * @param {object} state The current state of app
 */
const inspectVast = state => {
  if (state.vastSource.length && state.player) {
    if (globalThis.sas.video) {
      stopPlayer(state.player.name, state.player.containerId);
      try {
        registerPlugin(state, null, null, state.vastSource);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('Error was catched ', error);
      }
      startPlayer(state.player.name, state.player.containerId);
    }
  }
};

/**
 * Helper function to register plugin for content player
 * @param {object} state The current state of app
 */
const registerPlugin = (state, dataPlacement, adRules, externalUrl) => {
  if (globalThis.sas?.video !== undefined) {
    try {
      globalThis.sas.video.clearPlayer(state.player.containerId);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Unable to clear player ', error);
    }
    //clear all companions from slot testCompanion, this is a workaround for a case if someone click start test several times
    const companionChildren = document.getElementById('testCompanion').children;
    for (let i = companionChildren.length; i--; i > 0) {
      if (companionChildren[i].id !== `testCompanionHeader`) {
        document.getElementById('testCompanion').removeChild(companionChildren[i]);
      }
    }
    document.getElementById('testCompanionHeader').className = '';

    let data = {
      contentPlayer: {
        api: null,
      },
      id: state.player.containerId,
      adData:
        dataPlacement === null
          ? {
              sas_siteid: '44928',
              sas_pageid: '901111',
              sas_format_linears: '27153',
              sas_format_overlays: '27154',
            }
          : dataPlacement,
      adRules:
        state.activeSection !== 0 && adRules !== null
          ? adRules.data
          : [
              {
                duration_min: 0,
                duration_max: -1,
                data: {
                  prerolls: {
                    instances: 1,
                  },
                },
              },
            ],
      debugMode: {
        handler: state.logHandler,
      },
      externalUrls: {
        externalVastUrl: externalUrl === null ? '' : externalUrl,
        preroll: true,
      },
      configuration: state.activeSection === 0 ? initStateObj.configuration : state.configuration,
      contentData: state.activeSection === 0 ? initStateObj.other.content : state.other.content,
      user: state.activeSection === 0 ? initStateObj.other.user : state.other.user,
    };

    if (isMobile) {
      data.configuration.publisher.muteAdsAtStartup = true;
    }

    if (state.player.name === 'flowplayer') {
      if (globalThis.sas?.video !== undefined) {
        let api = globalThis.flowplayer();

        data.contentPlayer.api = api;
        globalThis.sas.video.register(data);
        if (isMobile && globalThis.flowplayer().video.duration === undefined) {
          //fix for flowplayer version 6 https://smartadserver.atlassian.net/browse/SADR-339
          // no video object was created, so we call load method to embed the video tag, to make it accessible for plugin
          globalThis
            .flowplayer()
            .bind('load', () => {
              globalThis.flowplayer().stop();
            })
            .load();
        } else {
          api.trigger('ready', [api, api.video]);
        }
      }
    } else {
      globalThis.sas.video.register(data);
    }
  }
};

/**
 * Helper function to remove ad rule and set the new cookie value
 * @param {object} action redux Action object
 * @param {object} state The current state of app
 */
const removeAdRuleAction = (action, state) => {
  let adRules = JSON.parse(JSON.stringify(state.adRules)),
    adRulesArray = adRules.data;

  adRulesArray.splice(action.index, 1);
  if (!adRulesArray.length) {
    adRulesArray.push({
      data: {},
    });
  }

  setLocalStorage('adRules', JSON.stringify(adRules));
  setTimeout(updateSize, 0);

  return {
    type: UPDATE_AD_RULES,
    adRules: adRules,
  };
};

/**
 * Helper function to update ad break in an ad rule and set the new cookie value
 * @param {object} action redux Action object
 * @param {object} state The current state of app
 */
const updateAdBreakAction = (action, state) => {
  let adRules = JSON.parse(JSON.stringify(state.adRules)),
    data = action.data;

  adRules.data[data.index].data[data.type] = Object.assign(
    {},
    adRules.data[data.index].data[data.type],
    data.data
  );

  if (adRules.isValid) {
    setLocalStorage('adRules', JSON.stringify(adRules));
  }

  return {
    type: UPDATE_AD_RULES,
    adRules: adRules,
  };
};

/**
 * Helper function to update ad rule and set the new cookie value
 * @param {object} action redux Action object
 * @param {object} state The current state of app
 */
const updateAdRuleAction = (action, state) => {
  let adRules = JSON.parse(JSON.stringify(state.adRules)),
    data = action.data;

  adRules.isValid = data.isValid;

  if (data.index !== undefined) {
    adRules.data[data.index] = data.adRule;
  }

  if (adRules.isValid) {
    setLocalStorage('adRules', JSON.stringify(adRules));
  }

  return {
    type: UPDATE_AD_RULES,
    adRules: adRules,
  };
};

/**
 * Helper function to update the plugin with the new data
 * @param {object} state The current state of app
 */
const updatePluginWithData = state => {
  if (
    !state.adData.isValid ||
    !state.adRules.isValid ||
    !state.configuration.isValid ||
    !state.other.isValid
  ) {
    return;
  }
  let adData = {
    sas_siteid: state.adData.sas_siteid,
    sas_pageid: state.adData.sas_pageid,
    sas_format_linears: state.adData.sas_format_linears,
    sas_format_overlays: state.adData.sas_format_overlays,
    sas_target: state.adData.sas_target,
  };
  if (state.player && globalThis.sas?.video) {
    stopPlayer(state.player.name, state.player.containerId);
    try {
      registerPlugin(state, adData, state.adRules, null);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error was catched ', error);
    }
    startPlayer(state.player.name, state.player.containerId);
  }
};

/**
 * Helper function to parse and prepare readable version of logs
 * @param {object} action redux Action object
 * @param {object} state The current state of app
 */
const updateLogAction = (action, state) => {
  let newActionLogs = {},
    log = getVastParserLog(action.logs);
  if (
    log !== null &&
    checkUniqueError(state.logs, action.logs, ['parserLogError', 'generalError'])
  ) {
    newActionLogs = {
      log: log,
      time: getCurrentDate(),
      type: action.logs.type,
    };
  }

  return {
    type: UPDATE_LOGS,
    logs: newActionLogs,
  };
};
/*TO DO*/
const validateImportSettings = action => {
  if (action.data.adData) {
    action.data.adData.isValid = validatePlacementData(action.data.adData);
  }
  if (action.data.adRules.data.length > 0) {
    let isValid = validateAdRules(action.data.adRules);
    if (isValid === true) {
      setLocalStorage('adRules', JSON.stringify(action.data.adRules));
    }
    action.data.adRules.isValid = isValid;
  }
  if (action.data.configuration) {
    action.data.configuration.isValid = validateConfiguration(action.data.configuration);
  }
  if (action.data.other) {
    action.data.other.isValid = validateOther(action.data.other);
  }
  return {
    type: IMPORT_SETTINGS,
    data: action.data,
  };
};
/*TO DO*/
const validatePlacementData = adData => {
  let isValid = true;
  isValid =
    inputsValidator(adData.sas_siteid, true, 'number').isValid &&
    inputsValidator(adData.sas_pageid, true, 'number').isValid &&
    inputsValidator(adData.sas_networkid, false, 'number').isValid &&
    inputsValidator(adData.sas_target, false, 'string').isValid &&
    (!adData.sas_format_linears.length && !adData.sas_format_overlays.length
      ? false
      : (adData.sas_format_linears.length
          ? inputsValidator(adData.sas_format_linears, true, 'number').isValid
          : true) &&
        (adData.sas_format_overlays.length
          ? inputsValidator(adData.sas_format_overlays, true, 'number').isValid
          : true));
  return isValid;
};
/*TO DO*/
const validateAdRules = adRules => {
  let isValid = true;
  adRules.data.forEach(element => {
    let duration_min = Number.parseInt(element.duration_min, 10),
      duration_max = Number.parseInt(element.duration_max, 10);
    if (
      (duration_max !== -1 && duration_min > duration_max) ||
      !inputsValidator(duration_min, true, 'number', 0).isValid ||
      !inputsValidator(duration_max, true, 'number', -1).isValid
    ) {
      isValid = false;
    }
  });
  return isValid;
};
/*TO DO*/
const validateConfiguration = configuration => {
  let isValid = true;
  isValid =
    inputsValidator(configuration.publisher.bumperDuration, true, 'number', 0).isValid &&
    inputsValidator(configuration.publisher.integralAdScienceAnId, true, 'number').isValid &&
    inputsValidator(configuration.publisher.skipDelay, true, 'number').isValid &&
    inputsValidator(configuration.publisher.totalTimeout, true, 'number', 0).isValid &&
    inputsValidator(configuration.publisher.numberOfPassbackAds, true, 'number', -1).isValid &&
    inputsValidator(configuration.publisher.requestTimeout, true, 'number', 0).isValid &&
    inputsValidator(configuration.publisher.numMaxRedirect, true, 'number', 1).isValid &&
    inputsValidator(configuration.publisher.visibilityThresholdForPlayback, true, 'number', -1)
      .isValid &&
    inputsValidator(configuration.publisher.visibilityThresholdForUnmute, true, 'number', -1)
      .isValid &&
    inputsValidator(configuration.vpaid.generalTimeout, true, 'number', 0).isValid &&
    inputsValidator(configuration.vpaid.initTimeout, true, 'number', 0).isValid &&
    inputsValidator(configuration.vpaid.loadTimeout, true, 'number', 0).isValid &&
    inputsValidator(configuration.vpaid.totalTimeout, true, 'number', 0).isValid &&
    inputsValidator(configuration.rtb.vdmin, false, 'number', 1).isValid &&
    inputsValidator(configuration.rtb.vdmax, false, 'number', 1).isValid &&
    inputsValidator(configuration.rtb.vbrmin, false, 'number', 1).isValid &&
    inputsValidator(configuration.rtb.vbrmax, false, 'number', 1).isValid &&
    inputsValidator(configuration.rtb.vpmt, false, 'number').isValid &&
    inputsValidator(configuration.rtb.pgDomain, false, 'string', 1).isValid;
  return isValid;
};

const validateOther = other => {
  let isValid = true;
  isValid =
    inputsValidator(other.content.sas_contentid, false, 'string', 0).isValid &&
    inputsValidator(other.content.sas_videoContentDuration, false, 'number', 1).isValid;

  return isValid;
};

export default showcaseMiddleware;
export { logger };
